import DashboardPage from '@/views/restricted/dashboard/DashboardPage.vue'
import DistributorLayout from '@/layouts/DistributorLayout.vue'
import RepairFileListPage from '@/views/restricted/dashboard/RepairFileListPage.vue'

export default [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout
    }
  },
  {
    path: '/dashboard/repair-file',
    name: 'RepairFileListPage',
    component: RepairFileListPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout
    }
  }
]
